export default __webpack_public_path__ + "static/media/order-down.0eac0909.svg";